<template>
  <div class="columns is-vcentered">
    <div class="column is-1 is-cursor-pointer" @click="selectAll()">
      <b-icon class="mgt-5px" :icon="iconSelectTotal"></b-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headerEmplacementDispositifMaterielFacePicker',
  props: {
    emplacements: {
      type: Array,
      required: true,
      default: null,
    },
  },
  computed: {
    allEmplacementSelected() {
      return this.getAllEmplacementSelected().length === this.emplacements.length
        && this.emplacements.length > 0;
    },
    iconSelectTotal() {
      if (this.allEmplacementSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
  },
  methods: {
    getAllEmplacementSelected() {
      return this.emplacements.filter((el) => {
        return el.selected;
      });
    },
    selectAll() {
      const select = !this.allEmplacementSelected;
      this.emplacements.forEach((emplacement) => {
        emplacement.selected = select;
        emplacement.dispositifs.forEach((dispositif) => {
          dispositif.selected = select;
          dispositif.materiels.forEach((materiel) => {
            materiel.selected = select;
          });
        });
      });
    },
  },
};
</script>

<style scoped>

</style>
